import * as React from 'react'
import { useCallback, useEffect } from 'react'

export function useDateCountdown(endDate: string) {
  const [timeToEnd, setTimeToEnd] = React.useState<string>('')
  const [counterEnded, setCounterEnded] = React.useState<boolean>(false)

  const pad = (value: number) => String(value).padStart(2, '0')

  const countTimeToEnd = useCallback((interval: NodeJS.Timeout) => {
    const deadline = new Date(endDate)
    const today = new Date()
    const timeDifference = deadline.getTime() - today.getTime()
    if (timeDifference <= 0) {
      setCounterEnded(true)
      clearInterval(interval)
      return
    }
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24))
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000)
    setTimeToEnd(`${pad(days)} : ${pad(hours)} : ${pad(minutes)} : ${pad(seconds)}`)
  }, [endDate])

  useEffect(() => {
    const interval: NodeJS.Timeout = setInterval(() => countTimeToEnd(interval), 1000)
    return () => {
      clearInterval(interval)
    }
  }, [])
  return {
    counterEnded,
    timeToEnd,
  }
}
